import React from 'react';
import { ControlSelector } from './ControlSelector.js';
import { AudioSettings } from './AudioSettings.js';
import { GraphicsSettings } from './GraphicsSettings.js';
import type { MenuLanguage, MenuSettings } from './types.js';

export function SettingsPanel({ language, settings, onChange, onClose, onPrivacy, onTerms, onRepeatTutorial }: {
  language: MenuLanguage; settings: MenuSettings;
  onChange: (patch: Partial<MenuSettings>) => void; onClose: () => void;
  onPrivacy: () => void; onTerms: () => void;
  onRepeatTutorial: () => void;
}) {
  const es = language === 'es';
  const tr = (s: string, e: string, f: string) => es ? s : language === 'fr' ? f : e;
  return <div className="settings-backdrop" onPointerDown={(event) => {
    if (event.target === event.currentTarget) onClose();
  }}>
    <aside className="settings-panel" role="dialog" aria-modal="true" aria-label={tr('Configuración', 'Settings', 'Paramètres')}>
      <header><div><strong>{tr('Configuración', 'Settings', 'Paramètres')}</strong>
        <span>{tr('Personaliza tu experiencia', 'Customize your experience', 'Personnalisez votre expérience')}</span></div>
        <button aria-label={tr('Cerrar configuración', 'Close settings', 'Fermer les paramètres')} onClick={onClose}>×</button></header>
      <div className="settings-scroll">
        <ControlSelector language={language} value={settings.controlScheme} sensitivity={settings.mouseSensitivity}
          onChange={(controlScheme) => onChange({ controlScheme })}
          onSensitivityChange={(mouseSensitivity) => onChange({ mouseSensitivity })} />
        <label className="menu-check"><input type="checkbox" checked={settings.vibration}
          onChange={(event) => onChange({ vibration: event.target.checked })} /> {tr('Vibración móvil', 'Mobile vibration', 'Vibration mobile')}</label>
        <AudioSettings language={language} sound={settings.soundVolume} music={settings.musicVolume}
          onSoundChange={(soundVolume) => onChange({ soundVolume })}
          onMusicChange={(musicVolume) => onChange({ musicVolume })} />
        <GraphicsSettings language={language} quality={settings.graphicsQuality}
          showFps={settings.showFps} showPing={settings.showPing} reduceShake={settings.reduceCameraShake}
          onChange={(patch) => onChange({ graphicsQuality: patch.quality, showFps: patch.showFps,
            showPing: patch.showPing, reduceCameraShake: patch.reduceShake })} />
        <section className="menu-setting-group tutorial-help">
          <strong>{tr('Ayuda', 'Help', 'Aide')}</strong>
          <small>{tr('Practica los controles y las mecánicas básicas.', 'Practice the controls and basic mechanics.', 'Entraînez-vous aux commandes et aux mécaniques de base.')}</small>
          <button onClick={onRepeatTutorial}>{tr('Repetir tutorial', 'Replay tutorial', 'Rejouer le tutoriel')}</button>
        </section>
        <div className="mobile-legal-links">
          <button onClick={onPrivacy}>{tr('Privacidad', 'Privacy', 'Confidentialité')}</button>
          <button onClick={onTerms}>{tr('Términos de uso', 'Terms of use', "Conditions d'utilisation")}</button>
        </div>
      </div>
    </aside>
  </div>;
}
